import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { translate } from 'react-i18next';

import CommonTable from '../components/CommonTable';
import TextFilterField from '../components/filters/TextFilterField';
import * as alertTypeActions from '../redux/modules/alertTypes';
import i18n from '../translations/i18n';

const propTypes = {
  fetchAlertTypes: PropTypes.func,
  t: PropTypes.func,
  alertTypes: PropTypes.any,
  loading: PropTypes.any,
};

class AlertTypeList extends React.Component {
  constructor(props) {
    super(props);

    this.fetchData = this.fetchData.bind(this);
  }

  componentWillMount() {
    this.initColumns();
    this.props.fetchAlertTypes();
  }

  itemEdit = (id) => {
    browserHistory.push(`/alert-types/modify/${id}`);
  };

  initColumns() {
    this.columns = [
      {
        header: this.props.t('id'),
        accessor: 'id',
        className: 'centerAlign',
        width: 60,
        filterMethod: (filter, row) => filter.value === row.id,
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="id" filter={filter} onFilterChange={onFilterChange} />
        ),
      },
      {
        header: this.props.t('name'),
        accessor: 'name',
        filterMethod: (filter, row) =>
          row.name.toLowerCase().startsWith(filter.value.toLowerCase()),
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="name" filter={filter} onFilterChange={onFilterChange} />
        ),
      },
      {
        header: this.props.t('minimum_value'),
        show: false,
        accessor: 'min_value',
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="min_value" filter={filter} onFilterChange={onFilterChange} />
        ),
      },
      {
        header: this.props.t('maximum_value'),
        show: false,
        accessor: 'max_value',
        filterRender: ({ filter, onFilterChange }) => (
          <TextFilterField name="max_value" filter={filter} onFilterChange={onFilterChange} />
        ),
      },
    ];
  }

  fetchData() {
    this.props.fetchAlertTypes();
  }

  render() {
    let data = [];
    if (this.props.alertTypes) {
      data = Object.values(this.props.alertTypes);
    }

    return (
      <CommonTable
        title={this.props.t('alert_type_list')}
        data={data}
        defaultPageSize={10}
        onItemEdit={this.itemEdit}
        loading={this.props.loading}
        columns={this.columns}
        onChange={this.fetchData}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    loading: state.alertTypes.fetching,
    alertTypes: state.alertTypes.entities,
  };
}

AlertTypeList.propTypes = propTypes;

const extended = translate(['translations'], { i18n })(AlertTypeList);
export default connect(mapStateToProps, alertTypeActions)(extended);



// WEBPACK FOOTER //
// ./src/containers/AlertTypeList.js